module.exports = {
    "BaseUrl": "https://api-v4.staging.primrose.health",
    "baseUrl2": "https://stagingnew.trillium.health",
    "systemName": "System dev"
}